import React, { FC } from 'react'
import HighLight from 'src/components/sections/teaser/Highlight'
import { preventOrphans, formatTextWithOrphans } from 'src/helpers/typography'
import { ISectionHeaderDescriptionProps } from './types'

export const SectionHeaderDescription: FC<ISectionHeaderDescriptionProps> = ({
  description,
  descriptionVariant = 'highlight',
  descriptionClassName = '',
  descriptionWidthClass = 'md:w-6/12',
  isFullWidthDescription = false,
  disableBalance = false,
  subDescription,
  subDescriptionClassName = '',
  subDescriptionWidth,
  center = false,
  contentOnly = false,
  isSplitLayout = false,
  contentRef,
  subDescriptionRef,
}) => {
  if (!description && !subDescription) return null

  const resolvedSubDescriptionWidth =
    subDescriptionWidth || (isFullWidthDescription ? 'w-full' : descriptionWidthClass || 'md:w-6/12')

  const highlightAlignClass = center
    ? 'justify-center text-center'
    : 'justify-start text-left'

  const highlightOpacityClass = isSplitLayout
    ? contentRef ? 'opacity-0' : ''
    : contentOnly ? '' : 'opacity-0'

  const subDescAlignClass = center
    ? 'text-center'
    : 'text-left'

  return (
    <div className="w-full flex flex-col gap-base md:gap-semi-large xl:gap-extra-large">
      {description && (
        <HighLight
          ref={contentRef}
          variant={descriptionVariant}
          className={`${highlightAlignClass} text-on-surface ${descriptionClassName} ${highlightOpacityClass}`}
          isFullWidth={isSplitLayout || isFullWidthDescription}
          widthClass={isSplitLayout ? undefined : (descriptionWidthClass || 'md:w-6/12')}
          disableBalance={disableBalance}
        >
          {description}
        </HighLight>
      )}

      {subDescription && (
        <div
          ref={subDescriptionRef}
          className={`${subDescAlignClass} text-on-surface-variant ${descriptionClassName} ${contentOnly && !isSplitLayout ? '' : 'opacity-0'}`}
        >
          <div className={`${isSplitLayout ? 'w-full' : resolvedSubDescriptionWidth} ${subDescriptionClassName}`}>
            {typeof subDescription === 'string' ? (
              subDescription.includes('\n\n') ? (
                <div className="space-y-4">
                  {subDescription.split(/\n\s*\n/).map((paragraph, index) => (
                    <p
                      key={index}
                      className={`text-body-medium lg:text-body-medium xl:text-body-large font-medium text-on-surface-subtle ${subDescAlignClass} ${
                        disableBalance ? '' : '[text-wrap:pretty] lg:[text-wrap:balance]'
                      }`}
                    >
                      {preventOrphans(paragraph)}
                    </p>
                  ))}
                </div>
              ) : (
                <p
                  className={`text-body-medium lg:text-body-medium xl:text-body-large font-medium text-on-surface-subtle ${subDescAlignClass} ${
                    disableBalance ? '' : '[text-wrap:pretty] lg:[text-wrap:balance]'
                  }`}
                >
                  {preventOrphans(subDescription)}
                </p>
              )
            ) : (
              formatTextWithOrphans(subDescription)
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default SectionHeaderDescription
